<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('application.utilitymodel.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('application.title') }} > </span>
          <span class="middle_loc">{{ $t('application.utilitymodel.title2') }} > </span>
          <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <ValidationObserver ref="utilityModelInfo">
          <v-form>
            <v-flex class="inner_basic_wrap type2">
              <v-layout class="step_wrapper type3">
                <v-flex class="active step_box step01">
                  <h2>{{ $t('application.utilitymodel.fields.step_01') }}</h2>
                  <p>
                    {{ $t('application.utilitymodel.fields.select_type_and_input') }}
                    <br/>
                    {{ $t('application.utilitymodel.fields.related_application') }}
                  </p>
                </v-flex>
                <v-flex class="step_box step02">
                  <h2>{{ $t('application.utilitymodel.fields.step_02') }}</h2>
                  <p>{{ $t('application.utilitymodel.fields.write_application') }}</p>
                </v-flex>
                <v-flex class="step_box step03">
                  <h2>{{ $t('application.utilitymodel.fields.step_03') }}</h2>
                  <p>{{ $t('application.utilitymodel.fields.attach_file(s)') }}</p>
                </v-flex>
                <v-flex class="step_box step04">
                  <h2>{{ $t('application.utilitymodel.fields.step_04') }}</h2>
                  <p>{{ $t('application.utilitymodel.fields.review_submit') }}</p>
                </v-flex>
                <v-flex class="step_box step05">
                  <h2>{{ $t('application.utilitymodel.fields.step_05') }}</h2>
                  <p>{{ $t('application.utilitymodel.fields.payment') }}</p>
                </v-flex>
              </v-layout>

              <v-layout class="partent_step_radio mt-30">
                <h2 class="m_title">{{ $t('application.utilitymodel.fields.application_type') }}</h2>
                <v-row column>
                  <v-col cols="12">
                    <v-radio-group v-model="utilityModelInfo.domain_sub_type_code" :mandatory="false" class="pct__numb__wrapper">
                      <v-col cols="12" md="6" class="d-flex align-center pct__numb__wrap">
                        <v-radio color="#a01c2a" style="white-space:nowrap" :label="$t('application.utilitymodel.fields.pct_application_no')" value="2501"></v-radio>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <div class="text__input__icontype" style="height:40px;">
                          <div class="text__input__icontype__tf">
                            <v-text-field
                            outlined
                            solo
                            flat
                            dense
                            hide-details
                            ref="pctAppNo"
                            class="br_none"
                            clearable
                            :disabled="utilityModelInfo.domain_sub_type_code != '2501'"
                            v-model="searchApplicationNo"
                          ></v-text-field>
                          </div>
                          <v-btn
                            style="margin:0 -1px;"
                            outlined
                            dark
                            class="text-capitalize ft-size12 bd_none br_none btn-actv type2"
                            height="40"
                            @click="fnGetPctAppInfo()" :disabled="utilityModelInfo.domain_sub_type_code != '2501'">{{ $t('common.button.search') }}</v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex align-center">
                        <v-radio color="#a01c2a" :label="$t('application.utilitymodel.fields.national_utilitymodel_application')" value="2502"></v-radio>
                      </v-col>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-layout>


              <!-- PCT Application 선택해서 조회까지 했을 경우  -->
              <template v-if="utilityModelInfo.domain_sub_type_code == '2501' && pctAppSearchYn ">
                <div class="m_title">
                  {{ $t('application.utilitymodel.fields.international_application_no') }}
                </div>
                <v-layout class="partent_step_row">
                  <v-row>
                    <v-col>{{ $t('application.utilitymodel.fields.international_application_no') }}</v-col>
                    <v-col>{{ utilityModelInfo.international_application_no }}</v-col>
                    <v-col>{{ $t('application.utilitymodel.fields.intermational_application_date') }}</v-col>
                    <v-col>{{ utilityModelInfo.international_filing_date }}</v-col>
                  </v-row>
                </v-layout>
                <v-layout class="partent_step_row">
                  <v-row>
                    <v-col>{{ $t('application.utilitymodel.fields.pct_publication_id') }}</v-col>
                    <v-col>{{ utilityModelInfo.pct_publication_no }}</v-col>
                    <v-col>{{ $t('application.utilitymodel.fields.pct_publication_date') }}</v-col>
                    <v-col>{{ utilityModelInfo.pct_publication_date }}</v-col>
                  </v-row>
                </v-layout>
              </template>

              <template v-if="utilityModelInfo.domain_sub_type_code == '2501' && pctManual">
                <div class="ft-size12 pb--5 color_red">
                  {{ $t('application.fields.pct_application_no_manual_msg')}}
                </div>
                <div class="m_title">
                  {{ $t('application.utilitymodel.fields.pct_information') }}
                </div>
                <v-layout class="partent_step_row">
                  <v-row class="mt-20">
                    <v-col class="pa-15 pt--5">{{ $t('application.utilitymodel.fields.international_application_no') }}</v-col>
                    <v-col class="pa-15 pt--5">{{ utilityModelInfo.international_application_no }}</v-col>
                    <v-col class="pa-15 pt--5"><i>*</i> {{ $t('application.utilitymodel.fields.intermational_application_date') }}</v-col>
                    <v-col class="pa-15 pt--5">
                      <v-menu
                        ref="filingDateMenu"
                        v-model="filingDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.intermational_application_date')" :rules="{required: pctManual}">
                            <v-text-field
                              solo
                              dense
                              flat
                              outlined
                              clearable
                              readonly
                              v-on="on"
                              v-bind="attrs"
                              append-icon="mdi-calendar"
                              class="br_none date_type login_text_field"
                              hint="DD/MM/YYYY format"
                              v-model="utilityModelInfo.international_filing_date"
                              :error-messages="errors"
                              @click:append="filingDateMenu = true"
                              @click:clear="fnSetFilingDate"
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="international_filing_date" no-title @input="filingDateMenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-layout>
                <v-layout class="partent_step_row">
                  <v-row class="mt-20">
                    <v-col class="pa-15 pt--5">{{ $t('application.utilitymodel.fields.pct_publication_id') }}</v-col>
                    <v-col class="pa-15 pt--5">
                      <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.pct_publication_id')" :rules="{required: false, regex: /^(\d{4})\/(\d{6})$/}">
                        <v-text-field
                          outlined
                          solo
                          flat
                          dense
                          clearable
                          height="40px"
                          class="br_none ie_inpt login_text_field text-left email"
                          placeholder="YYYY/######"
                          :error-messages="errors"
                          v-model="utilityModelInfo.pct_publication_no"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col class="pa-15 pt--5">{{ $t('application.utilitymodel.fields.pct_publication_date') }}</v-col>
                    <v-col class="pa-15 pt--5">
                      <v-menu
                        ref="filingDateMenu"
                        v-model="publicationDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.pct_publication_date')" :rules="{required: false}">
                            <v-text-field
                              solo
                              dense
                              flat
                              outlined
                              clearable
                              readonly
                              v-on="on"
                              v-bind="attrs"
                              append-icon="mdi-calendar"
                              class="br_none date_type login_text_field"
                              hint="DD/MM/YYYY format"
                              v-model="utilityModelInfo.pct_publication_date"
                              :error-messages="errors"
                              @click:append="publicationDateMenu = true"
                              @click:clear="fnSetPublicationDate"
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="pct_publication_date" no-title @input="publicationDateMenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-layout>
              </template>

              <v-layout class="inner_contents" column>
                <h2 class="m_title"><i>*</i> {{ $t('application.utilitymodel.fields.title') }}</h2>
                <v-flex class="item_box ty2">

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.title_ar')" :rules="{required: true}">
                  <div class="text__input__icontype not__ltr">
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="type_ar ie_inpt login_text_field text-right br_none"
                        v-model="utilityModelInfo.title_ar"
                        :error-messages="errors"
                      ></v-text-field>
                    </div>
                    <div class="box__title">{{$t('application.utilitymodel.fields.ar')}}</div>
                  </div>
                  </ValidationProvider>

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.title_en')" :rules="{required: true}">
                  <div class="text__input__icontype not__ltr mt-15">
                    <div class="box__title">{{$t('application.utilitymodel.fields.en')}}</div>
                    <div class="text__input__icontype__tf">
                      <v-text-field
                        outlined
                        solo
                        flat
                        dense
                        class="br_none ie_inpt login_text_field text-left"
                        v-model="utilityModelInfo.title_en"
                        :error-messages="errors"
                      ></v-text-field>
                    </div>
                  </div>
                  </ValidationProvider>
                </v-flex>

                <h2 class="m_title"><i>*</i> {{ $t('application.utilitymodel.fields.abstract') }}</h2>
                <v-flex class="item_box ty2">

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.abstract_ar')" :rules="{required: true}">
                  <div class="text__textarea__icontype not__ltr">
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-right"
                        width="100%"
                        v-model="utilityModelInfo.abstract_ar"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                    <div class="box__title">{{$t('application.utilitymodel.fields.ar')}}</div>
                  </div>
                  </ValidationProvider>

                  <ValidationProvider v-slot="{ errors }" :name="$t('application.utilitymodel.fields.abstract_en')" :rules="{required: true}">
                  <div class="text__textarea__icontype not__ltr mt-20">
                    <div class="box__title">{{$t('application.utilitymodel.fields.en')}}</div>
                    <div class="text__textarea__icontype__tf">
                      <v-textarea
                        outlined
                        class="br_none ie_textarea login_text_field text-left"
                        width="100%"
                        v-model="utilityModelInfo.abstract_en"
                        :error-messages="errors"
                        no-resize
                      >
                      </v-textarea>
                    </div>
                  </div>
                  </ValidationProvider>
                </v-flex>
              </v-layout>

              <h2 class="m_title">
                {{ $t('application.utilitymodel.fields.application_for_a_patent_of_divisible_application_otherwise_associated_with_one_or_more_other_applications') }}
              </h2>
              <v-layout class="partent_step_tit">
                <span>{{ $t('application.utilitymodel.fields.application_or_patent_number_of_the_other_application_or_patent') }}</span>
              </v-layout>
              <v-layout class="partent_step_input">
                <v-row>
                  <v-col>
                    <v-text-field
                      solo
                      flat
                      dense
                      height="40px"
                      placeholder="EG/P/YYYY/#####"
                      class="br_none ie_inpt login_text_field text-left"
                      v-model="searchOrgApplicationNo"
                    ></v-text-field>
                    <v-btn @click="fnGetOrgAppInfo()">{{ $t('common.button.search') }}</v-btn>
                  </v-col>
                </v-row>
              </v-layout>

              <template v-if="fnIsNotNull(utilityModelInfo.orginal_application.application_no)">
                <div class="pa-20">
                  <div class="v-data-table new__type__table theme--light mt-20">
                    <div class="important_color ft-medium ft-size12 pb--5" v-if="
                      utilityModelInfo.orginal_application.status_type_code === '7113'
                        || utilityModelInfo.orginal_application.status_type_code === '7117'
                        || utilityModelInfo.orginal_application.status_type_code === '7119'
                        || utilityModelInfo.orginal_application.status_type_code === '7123'
                        || utilityModelInfo.orginal_application.status_type_code === '7124'
                        || utilityModelInfo.orginal_application.status_type_code === '7125'
                      ">{{ $t('application.utilitymodel.fields.division_status_error_msg')}}</div>
                    <div class="v-data-table__wrapper">
                      <table>
                        <thead class="v-data-table-header">
                          <tr>
                            <th role="columnheader" scope="col" aria-label="Applicant No.: Not sorted. Activate to sort ascending." aria-sort="none" class="text-left sortable" style="width: 135px; min-width: 135px;"><span>{{ $t('application.utilitymodel.fields.application_no') }}</span></th>
                            <th role="columnheader" scope="col" aria-label="Title: Not sorted. Activate to sort ascending." aria-sort="none" class="text-center sortable"><span>{{ $t('application.utilitymodel.fields.title') }}</span></th>
                            <th role="columnheader" scope="col" aria-label="Status: Not sorted. Activate to sort ascending." aria-sort="none" class="text-center sortable"><span>{{ $t('myapplication.fields.status') }}</span></th>
                            <th role="columnheader" scope="col" aria-label="Title: Not sorted. Activate to sort ascending." aria-sort="none" class="text-center sortable" style="width: 60px; min-width: 60px;"><span></span></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-start">{{ utilityModelInfo.orginal_application.application_no }}</td>
                            <td>{{ $vuetify.rtl ? utilityModelInfo.orginal_application.title_ar : utilityModelInfo.orginal_application.title_en }}</td>
                            <td>
                              <span :class="(
                                utilityModelInfo.orginal_application.status_type_code === '7113'
                                  || utilityModelInfo.orginal_application.status_type_code === '7117'
                                  || utilityModelInfo.orginal_application.status_type_code === '7119'
                                  || utilityModelInfo.orginal_application.status_type_code === '7123'
                                  || utilityModelInfo.orginal_application.status_type_code === '7124'
                                  || utilityModelInfo.orginal_application.status_type_code === '7125'
                                ) ? 'important_color ft-medium':''
                                ">
                                  {{ $vuetify.rtl ? utilityModelInfo.orginal_application.status_name_ar : utilityModelInfo.orginal_application.status_name_en }}
                              </span>
                            </td>
                            <td class="text-center">
                              <v-btn small icon @click="fnDeleteOrg()">
                                <v-icon small>mdi-close</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <v-row class="ma-0" style="background:#f2f2f2;">
                    <v-col cols="12" class="d-flex justify-start pa-20 pt--15 pb--15">
                      <div style="flex-direction: column;">
                        <div class="d-flex align-center">
                          <v-checkbox
                            color="#a01c2a"
                            value="Y"
                            hide-details
                            class="mt-0"
                            v-model="utilityModelInfo.orginal_application.ind_divisional_app"
                            :disabled="(
                              utilityModelInfo.orginal_application.status_type_code === '7113'
                                || utilityModelInfo.orginal_application.status_type_code === '7117'
                                || utilityModelInfo.orginal_application.status_type_code === '7119'
                                || utilityModelInfo.orginal_application.status_type_code === '7123'
                                || utilityModelInfo.orginal_application.status_type_code === '7124'
                                || utilityModelInfo.orginal_application.status_type_code === '7125'
                              ) ? true:false"
                          >
                          </v-checkbox>
                          <v-spacer class="hidden_lr2"></v-spacer>
                          <span class="ft-size12">{{ $t('application.fields.ind_divisional_app') }}</span>
                        </div>
                        <div class="d-flex align-center">
                          <v-checkbox
                            color="#a01c2a"
                            value="Y"
                            hide-details
                            class="mt-0"
                            v-model="utilityModelInfo.orginal_application.ind_earlier_app"
                            :disabled="(
                              utilityModelInfo.orginal_application.status_type_code === '7113'
                                || utilityModelInfo.orginal_application.status_type_code === '7117'
                                || utilityModelInfo.orginal_application.status_type_code === '7119'
                                || utilityModelInfo.orginal_application.status_type_code === '7123'
                                || utilityModelInfo.orginal_application.status_type_code === '7124'
                                || utilityModelInfo.orginal_application.status_type_code === '7125'
                              ) ? true:false"
                          >
                          </v-checkbox>
                          <v-spacer class="hidden_lr2"></v-spacer>
                          <span class="ft-size12">{{ $t('application.fields.ind_earlier_app') }}</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </template>

              <v-layout class="m_title mt-20">
                <span>{{ $t('application.utilitymodel.fields.did_the_application_related_to_micro_organizm_protection') }}</span>
              </v-layout>
              <v-layout class="partent_step_radio pt--10">
                <v-radio-group
                  v-model="utilityModelInfo.ind_micro_org_protection"
                  :mandatory="false"
                >
                  <v-col cols="12">
                    <v-radio color="#a01c2a" style="width:80px" :label="$t('application.utilitymodel.fields.yes')" value="Y"></v-radio>
                    <v-radio color="#a01c2a" style="width:80px" :label="$t('application.utilitymodel.fields.no')" value="N"></v-radio>
                  </v-col>
                </v-radio-group>
              </v-layout>

              <v-layout class="inner_contents" column v-show="utilityModelInfo.ind_micro_org_protection == 'Y'">
                <v-flex class="item_box pa-0">
                  <h2 class="m_title">{{ $t('application.utilitymodel.fields.deposit_of_live_farm') }}</h2>
                  <div class="file_inpt pa-20 pb-0 fileForm">
                    <v-file-input
                      flat
                      dense
                      outlined
                      accept=".pdf, .jpg, .gif"
                      :disabled="utilityModelInfo.ind_micro_org_protection === 'N'"
                      :placeholder="utilityModelInfo.micro_org_file_name ? utilityModelInfo.micro_org_file_name : $t('application.utilitymodel.fields.no_files_selected')"
                      :prepend-icon="$t('common.common.select_file')"
                      class="login_text_filed modf__file__inpt"
                      v-model="microOrgFile"
                      @change="fnUploadMicroOrgFile()"
                      clearable
                      @click:clear="fnInitMicroOrgFile()"
                      :append-icon="utilityModelInfo.micro_org_file_name ? '$clear':''"
                      @click:append="fnInitMicroOrgFile()"
                    >
                    </v-file-input>
                  </div>
                </v-flex>
              </v-layout>

              <h2 class="m_title mt-20">
                {{ $t('application.utilitymodel.fields.pph_request') }}
              </h2>
              <v-layout class="partent_step_radio mt-20">
                <v-radio-group
                  v-model="utilityModelInfo.ind_request_pph"
                  :mandatory="false"
                >
                  <v-col cols="12">
                    <v-radio style="width:80px;" color="#a01c2a" :label="$t('application.utilitymodel.fields.yes')" value="Y"></v-radio>
                    <v-radio style="width:80px;" color="#a01c2a" :label="$t('application.utilitymodel.fields.no')" value="N"></v-radio>
                  </v-col>
                </v-radio-group>
              </v-layout>

              <div v-show="utilityModelInfo.ind_request_pph == 'Y'">
                <v-layout class="inner_contents" column>
                  <h2 class="m_title"><i>*</i> {{ $t('application.fields.pph_document_file') }}</h2>
                  <v-flex class="item_box">
                    <div class="file_inpt fileForm">
                      <ValidationProvider v-slot="{ errors }"
                        :name="$t('application.fields.pph_document_file')"
                        :rules="{required: utilityModelInfo.ind_request_pph === 'Y' && !fnIsNotNull(utilityModelInfo.pph_doc_file_key)}">
                        <v-file-input
                          solo
                          flat
                          dense
                          outlined
                          accept=".pdf, .jpg, .gif"
                          :placeholder="utilityModelInfo.pph_doc_file_name ? utilityModelInfo.pph_doc_file_name : $t('application.utilitymodel.fields.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="login_text_filed"
                          v-model="pphDocFile"
                          @change="fnUploadPphDocFile()"
                          :disabled="utilityModelInfo.ind_request_pph === 'N'"
                          :error-messages="errors"
                          clearable
                          @click:clear="fnInitPphDocFile()"
                          :append-icon="utilityModelInfo.pph_doc_file_name ? '$clear': ''"
                          @click:append="fnInitPphDocFile()"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout class="mt-40">
                <v-spacer></v-spacer>
                <v-btn
                  height="50"
                  width="150"
                  class="btn-normal br_none btn-actv"
                  @click="fnSave()"
                  :loading="loadingSave"
                  :disabled="loadingSave"
                >
                  {{ $t('common.button.save') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-btn
                  color="#a01c2a"
                  dark
                  min-width="150"
                  min-height="50"
                  class="btn-normal br_none"
                  @click="fnGoNextStep()"
                  :loading="loadingNext"
                  :disabled="loadingNext"
                >
                  {{ $t('common.button.save_next') }}
                  <v-icon dark right>mdi-check</v-icon>
                </v-btn>
              </v-layout>

            </v-flex>
          </v-form>
        </ValidationObserver>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name : 'UtilityModelStep1',
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      searchApplicationNo : '',
      loadingSave: false,
      loadingNext: false,
      pctAppSearchYn : false,
      pctManual: false,
      filingDateMenu: false,
      publicationDateMenu: false,
      pct_publication_date: this.$moment().format('YYYY-MM-DD'),
      international_filing_date: this.$moment().format('YYYY-MM-DD'),

      searchOrgApplicationNo : '',

      receipt_no : this.$route.params.receipt_no,
      utilityModelInfo : {
        filing_seq : '',
        title_ar : '',
        title_en : '',
        abstract_ar : '',
        abstract_en : '',
        ind_abs_translation_ar : 'N',
        ind_abs_translation_en : 'N',
        ind_micro_org_protection : 'Y',
        micro_org_file_key: '',
        micro_org_file_name: '',

        domain_sub_type_code : '2501',
        // 2501 일때
        international_application_no : '',
        international_filing_date : '',

        pct_publication_country_code : '',
        pct_publication_date : '',
        pct_publication_no : '',
        ind_pct_manual: '',

        orginal_application : {},
        ind_request_pph : 'Y',
        pph_doc_file_key: '',
        pph_doc_file_name: ''
      },

      microOrgFile : null,
      pphDocFile : null,
      applicationYn: false,

      ind_abs_translation_ar: '',
      ind_abs_translation_en: ''
    }
  },
  watch: {
    ind_abs_translation_ar (val) {
      if (val === 'Y') {
        this.ind_abs_translation_en = null
      }
    },
    ind_abs_translation_en (val) {
      if (val === 'Y') {
        this.ind_abs_translation_ar = null
      }
    },
    international_filing_date () {
      this.utilityModelInfo.international_filing_date = this.$moment(this.international_filing_date).format('DD/MM/YYYY')
    },
    pct_publication_date () {
      this.utilityModelInfo.pct_publication_date = this.$moment(this.pct_publication_date).format('DD/MM/YYYY')
    },
  },
  mounted(){
    window.scrollTo(0, 0)
    this.pct_publication_date = this.$moment().format('YYYY-MM-DD')
    this.international_filing_date = this.$moment().format('YYYY-MM-DD')

    this.fnGetReceipt()
    this.fnGetUtilityModel()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6403'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnDeleteOrg(){
      this.utilityModelInfo.orginal_application = {}
    },
    fnGetUtilityModel(){
      requestApi({
        url: '/receivings/utility/' + this.receipt_no + '/filing',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.utilityModelInfo.filing_seq                   = res.data.seq
            this.utilityModelInfo.title_ar                     = res.data.title_ar
            this.utilityModelInfo.title_en                     = res.data.title_en
            this.utilityModelInfo.abstract_ar                  = res.data.abstract_ar
            this.utilityModelInfo.abstract_en                  = res.data.abstract_en
            this.utilityModelInfo.ind_abs_translation_ar       = res.data.ind_abs_translation_ar
            this.utilityModelInfo.ind_abs_translation_en       = res.data.ind_abs_translation_en
            this.utilityModelInfo.ind_micro_org_protection     = res.data.ind_micro_org_protection
            this.utilityModelInfo.micro_org_file_key           = res.data.micro_org_file_key
            this.utilityModelInfo.micro_org_file_name           = res.data.micro_org_file_name
            this.utilityModelInfo.domain_sub_type_code         = res.data.domain_sub_type_code
            this.utilityModelInfo.international_application_no = res.data.international_application_no
            this.utilityModelInfo.international_filing_date    = (res.data.international_filing_date) ? this.$moment(res.data.international_filing_date, 'DD-MM-YYYY').format('DD/MM/YYYY') : ''
            this.utilityModelInfo.pct_publication_date         = (res.data.pct_publication_date) ? this.$moment(res.data.pct_publication_date, 'DD-MM-YYYY').format('DD/MM/YYYY') : ''
            this.utilityModelInfo.pct_publication_no           = res.data.pct_publication_no
            this.utilityModelInfo.pct_publication_country_code = res.data.pct_publication_country_code
            this.utilityModelInfo.ind_pct_manual = res.data.ind_pct_manual

            this.ind_abs_translation_ar       = res.data.ind_abs_translation_ar
            this.ind_abs_translation_en       = res.data.ind_abs_translation_en

            if(Object.keys(res.data.orginal_application).length == 0){
              this.utilityModelInfo.orginal_application = {}
            }else{
              this.utilityModelInfo.orginal_application = res.data.orginal_application
            }

            this.utilityModelInfo.ind_request_pph = res.data.ind_request_pph
            this.utilityModelInfo.pph_doc_file_key = res.data.pph_doc_file_key
            this.utilityModelInfo.pph_doc_file_name = res.data.pph_doc_file_name

            // WIPO 정보
            if(!utils.isNull(res.data.international_application_no)){
              this.searchApplicationNo = res.data.international_application_no

              if (this.utilityModelInfo.ind_pct_manual === 'Y') {
                this.pctManual = true
                this.pctAppSearchYn = false
              } else if (this.utilityModelInfo.ind_pct_manual === 'N') {
                this.pctManual = false
                this.pctAppSearchYn = true
              }
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetUtilityModel()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetOrgAppInfo(){
      if (!this.searchOrgApplicationNo) {
        let snackBarOptions = {
          text: this.$t('common.message.enter_application_no')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      let params = {
        application_no :  this.searchOrgApplicationNo
      }
      requestApi({
        url: '/applications/original',
        method: 'GET',
        data : params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicationYn = true
            this.searchOrgApplicationNo = ''
            let orgApp = {}
            orgApp = {
              application_no     : res.data.application_no,
              title_ar           : res.data.title_ar,
              title_en           : res.data.title_en,
              status_name_ar: res.data.status_name_ar,
              status_name_en: res.data.status_name_en,
              status_type_code: res.data.status_type_code,
              ind_divisional_app : res.data.ind_divisional_app,
              ind_earlier_app    : res.data.ind_earlier_app,
              ipas_file_seq      : res.data.ipas_file_seq,
              ipas_file_typ      : res.data.ipas_file_typ,
              ipas_file_ser      : res.data.ipas_file_ser,
              ipas_file_nbr      : res.data.ipas_file_nbr
            }
            this.utilityModelInfo.orginal_application = orgApp
          }else{
            this.utilityModelInfo.orginal_application = {}
            this.applicationYn = false
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetOrgAppInfo()
              })
            } else{
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPctAppInfo(){
      if (!this.searchApplicationNo) {
        let snackBarOptions = {
          text: this.$t('common.message.enter_pct_application_no')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }
      let params = {
        pct_no :  this.searchApplicationNo,
        receipt_no: this.receipt_no
      }
      requestApi({
        url: '/applications/patentcodescope',
        method: 'POST',
        data : params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.utilityModelInfo.international_application_no = res.data.int_application_no
            this.utilityModelInfo.international_filing_date    = res.data.int_application_date
            this.utilityModelInfo.pct_publication_date         = res.data.pct_publication_date
            this.utilityModelInfo.pct_publication_no           = res.data.pct_publication_no
            this.utilityModelInfo.pct_publication_country_code = res.data.pct_publication_country_code

            this.utilityModelInfo.title_en                     = res.data.title_en
            this.utilityModelInfo.abstract_en                  = res.data.abstract_en

            this.pctAppSearchYn  = true
            this.pctManual = false
            this.utilityModelInfo.ind_pct_manual = 'N'
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPctAppInfo()
              })
            } else if (res.res_code === '400005') {
              // wipo 검색 결과가 없을 경우
              this.pctAppSearchYn  = false
              this.pctManual = true
              this.utilityModelInfo.ind_pct_manual = 'Y'
              this.utilityModelInfo.international_application_no = this.fnGetPctNo(this.searchApplicationNo)
              this.utilityModelInfo.international_filing_date = ''
              this.utilityModelInfo.pct_publication_date = ''
              this.utilityModelInfo.pct_publication_no = ''
              this.utilityModelInfo.pct_publication_country_code = this.fnGetPctCountryCode(this.searchApplicationNo)
            } else{
              this.pctAppSearchYn  = false
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSave() {
      this.loadingSave = true
      if(utils.isNull(this.utilityModelInfo.orginal_application)){
        this.utilityModelInfo.orginal_application = {}
      }else{
        if(utils.isNull(this.utilityModelInfo.orginal_application.ind_divisional_app)){
          this.utilityModelInfo.orginal_application.ind_divisional_app = 'N'
        }
        if(utils.isNull(this.utilityModelInfo.orginal_application.ind_earlier_app)){
          this.utilityModelInfo.orginal_application.ind_earlier_app = 'N'
        }
      }

      //pph 신청이 아닐 경우
      if(this.utilityModelInfo.ind_request_pph == 'N'){
        this.utilityModelInfo.pph_doc_file_key = ''
      }

      // 요약 번역 여부 체크박스이므로 체크 아닐경우는 N으로
      if(this.ind_abs_translation_ar !== 'Y'){
        this.ind_abs_translation_ar = 'N'
      }
      if(this.ind_abs_translation_en !== 'Y'){
        this.ind_abs_translation_en = 'N'
      }

      this.utilityModelInfo.ind_abs_translation_ar = this.ind_abs_translation_ar
      this.utilityModelInfo.ind_abs_translation_en = this.ind_abs_translation_en

      // National Utility Model Application 을 선택한 경우 PCT Application 관련 정보는 삭제
      if(this.utilityModelInfo.domain_sub_type_code == '2502'){
        this.utilityModelInfo.international_application_no = ''
        this.utilityModelInfo.international_filing_date = ''
        this.utilityModelInfo.pct_publication_date = ''
        this.utilityModelInfo.pct_publication_no = ''
        this.utilityModelInfo.pct_publication_country_code = ''
        this.utilityModelInfo.ind_pct_manual = 'N'
      }

      requestApi({
        url: '/receivings/utility/' + this.receipt_no + '/filing/save',
        method: 'PUT',
        data: this.utilityModelInfo,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.loadingSave = false
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSave()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.loadingSave = false
            }
          }
        }
      })
    },
    fnGoNextStep(){
      if(this.utilityModelInfo.domain_sub_type_code === '2501' && !this.pctAppSearchYn && !this.pctManual) {
        let snackBarOptions = {
          text: this.$t('application.utilitymodel.fields.pct_application_search')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        this.$refs.pctAppNo.focus()
        return
      }

      if(utils.isNull(this.utilityModelInfo.orginal_application)){
        this.utilityModelInfo.orginal_application = {}
      }else{
        if(utils.isNull(this.utilityModelInfo.orginal_application.ind_divisional_app)){
          this.utilityModelInfo.orginal_application.ind_divisional_app = 'N'
        }
        if(utils.isNull(this.utilityModelInfo.orginal_application.ind_earlier_app)){
          this.utilityModelInfo.orginal_application.ind_earlier_app = 'N'
        }
      }

      //pph 신청이 아닐 경우
      if(this.utilityModelInfo.ind_request_pph == 'N'){
        this.utilityModelInfo.pph_doc_file_key = ''
      }

      // 요약 번역 여부 체크박스이므로 체크 아닐경우는 N으로
      if(this.ind_abs_translation_ar !== 'Y'){
        this.ind_abs_translation_ar = 'N'
      }
      if(this.ind_abs_translation_en !== 'Y'){
        this.ind_abs_translation_en = 'N'
      }

      this.utilityModelInfo.ind_abs_translation_ar = this.ind_abs_translation_ar
      this.utilityModelInfo.ind_abs_translation_en = this.ind_abs_translation_en

      this.$refs.utilityModelInfo.validate().then((valid) => {
        if(valid){
          this.loadingNext = true
          // National Utility Model Application 을 선택한 경우 PCT Application 관련 정보는 삭제
          if(this.utilityModelInfo.domain_sub_type_code === '2502'){
            this.utilityModelInfo.international_application_no = ''
            this.utilityModelInfo.international_filing_date = ''
            this.utilityModelInfo.pct_publication_date = ''
            this.utilityModelInfo.pct_publication_no = ''
            this.utilityModelInfo.pct_publication_country_code = ''
            this.utilityModelInfo.ind_pct_manual = 'N'
          }

          requestApi({
            url: '/receivings/utility/' + this.receipt_no + '/filing',
            method: 'PUT',
            data: this.utilityModelInfo,
            callback: (res) => {
              if (res.res_code === '200') {
                let snackBarOptions = {
                  text: this.$t('common.message.add.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                // 이화면 처리 완료 될시에 화면 이동 처리!!
                this.$router.push({path:'/application/utilitymodel/step2/' + this.receipt_no})
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnGoNextStep()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  this.loadingNext = false
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },
    fnInitMicroOrgFile() {
      this.microOrgFile = null
      this.utilityModelInfo.micro_org_file_key = ''
      this.utilityModelInfo.micro_org_file_name = ''
    },
    // 미생물 보호 관련 파일 업로드
    fnUploadMicroOrgFile(){
      if(!utils.isNull(this.microOrgFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.microOrgFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.microOrgFile = null
            this.utilityModelInfo.micro_org_file_key = ''
            this.utilityModelInfo.micro_org_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.microOrgFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.utilityModelInfo.micro_org_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadMicroOrgFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.microOrgFile = null
                this.utilityModelInfo.micro_org_file_key = ''
                this.utilityModelInfo.micro_org_file_name = ''
              }
            }
          }
        })
      }
    },
    fnInitPphDocFile() {
      this.pphDocFile = null
      this.utilityModelInfo.pph_doc_file_key = ''
      this.utilityModelInfo.pph_doc_file_name = ''
    },
    fnUploadPphDocFile(){
      if(!utils.isNull(this.pphDocFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.pphDocFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.pphDocFile = null
            this.utilityModelInfo.pph_doc_file_key = ''
            this.utilityModelInfo.pph_doc_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.pphDocFile)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.utilityModelInfo.pph_doc_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadPphDocFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.pphDocFile = null
                this.utilityModelInfo.pph_doc_file_key = ''
                this.utilityModelInfo.pph_doc_file_name = ''
              }
            }
          }
        })
      }
    },
    fnIsNotNull(val){
      return !utils.isNull(val)
    },
    fnGetPctNo(pctNo) {
      let pctNos = pctNo.split('/')
      return pctNos[0] +'/'+ pctNos[1] +'/'+ utils.fillZero(pctNos[2], 6)
    },

    fnGetPctCountryCode(pctNo) {
      let pctNos = pctNo.split('/')
      return pctNos[1].substring(0, 2)
    },

    fnSetFilingDate() {
      this.utilityModelInfo.international_filing_date = ''
      this.international_filing_date = this.$moment().format('YYYY-MM-DD')
    },

    fnSetPublicationDate() {
      this.utilityModelInfo.pct_publication_date = ''
      this.pct_publication_date = this.$moment().format('YYYY-MM-DD')
    }
  }
}
</script>